/**
 * Project Bobcat — small action scripts the agent templates use that are the
 * same in every solution, so Create uploads the real thing instead of a
 * placeholder (`placeholder-scripts.ts`). Pure: the source text only.
 *
 * Both read their input the way the engine passes it: the Parameter Input
 * names a variable, and the engine sends a script only the variables in the
 * node's Variable column (`agent-spec-rows.ts` puts them there).
 */

/** "true" when the variable a Parameter Input names already has a value. */
const HAS_VALUE = `import re


class HasValue:
    """Whether a variable already has a value: "true" or "false".

    Parameter Input: {"value": "SOME_VARIABLE"}, with SOME_VARIABLE in the
    node's Variable column. Lets an agent confirm what the customer already
    gave ("Is this for order 45213?") instead of asking again.
    """

    NAME = re.compile(r'^\\{?([A-Z][A-Z0-9_]*)\\}?$')

    def execute(self, log, payload=None, context=None):
        payload = payload or {}
        try:
            given = str(payload.get('value') or '').strip()
            name = self.NAME.match(given)
            value = payload.get(name.group(1)) if name else given
            value = str(value if value is not None else '').strip()
            has = bool(value) and not (value.startswith('{') and value.endswith('}'))
            log(f'HasValue: {has}')
            return {'success': 'true' if has else 'false'}
        except Exception as err:
            log(f'HasValue error: {err}')
            return {'success': 'error'}
`;

/** A typed or spoken yes or no, for confirming on the phone as well as chat. */
const YES_NO = `import re


class YesNo:
    """A typed or spoken yes or no: "yes", "no" or "unclear".

    Parameter Input: {"answer": "SOME_VARIABLE"}, the variable the asking step
    kept the reply in, with it in the node's Variable column. Buttons can't be
    pressed on a phone line, so a confirmation is asked and read with this.
    """

    NAME = re.compile(r'^\\{?([A-Z][A-Z0-9_]*)\\}?$')
    YES = {'yes', 'yeah', 'yep', 'yup', 'sure', 'correct', 'right', 'ok',
           'okay', 'affirmative', 'absolutely', 'definitely', 'y'}
    NO = {'no', 'nope', 'nah', 'not', 'wrong', 'different', 'another',
          'other', 'incorrect', 'n'}

    def execute(self, log, payload=None, context=None):
        payload = payload or {}
        try:
            given = str(payload.get('answer') or '').strip()
            name = self.NAME.match(given)
            answer = payload.get(name.group(1)) if name else given
            words = set(re.findall(r"[a-z']+", str(answer or '').lower()))
            if "that's" in words and 'it' in words:
                words.add('yes')
            result = ('no' if words & self.NO
                      else 'yes' if words & self.YES else 'unclear')
            log(f'YesNo: {result}')
            return {'success': result}
        except Exception as err:
            log(f'YesNo error: {err}')
            return {'success': 'error'}
`;

export const HELPER_SCRIPTS: Readonly<Record<string, string>> = {
  HasValue: HAS_VALUE,
  YesNo: YES_NO,
};
